import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { TrendingUp } from 'lucide-react';

interface NinetyDayInteractiveChartCardThumbnailProps {
  isHovered?: boolean;
  alwaysVisible?: boolean;
}

export default function NinetyDayInteractiveChartCardThumbnail({ 
  isHovered = false, 
  alwaysVisible = false 
}: NinetyDayInteractiveChartCardThumbnailProps) {
  const baseScale = alwaysVisible ? 'scale-[0.4]' : 'scale-100';
  const hoverScale = isHovered ? 'scale-100' : baseScale;

  return (
    <div className={`transition-transform duration-300 origin-left ${hoverScale} ${isHovered ? 'z-50' : ''}`}>
      <Card className="w-[300px] shadow-sm">
        <CardHeader className="pb-3">
          <div className="flex items-center justify-between">
            <CardTitle className="text-sm font-medium">90-Day Cash Forecast</CardTitle>
            <TrendingUp className="h-4 w-4 text-green-500" />
          </div>
        </CardHeader>
        <CardContent>
          <div className="space-y-2">
            <div className="flex items-center justify-between text-xs">
              <span className="text-muted-foreground">Current</span>
              <span className="font-semibold">£287,450</span>
            </div>
            <div className="h-24 flex items-end gap-1">
              {[65, 70, 68, 72, 75, 78, 82, 85, 88, 90, 92, 95].map((height, i) => (
                <div key={i} className="flex-1 bg-blue-500 rounded-t" style={{ height: `${height}%` }} />
              ))}
            </div>
            <div className="flex items-center justify-between text-xs">
              <span className="text-muted-foreground">90 Days</span>
              <span className="font-semibold text-green-600">£342,100</span>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
